// extracted by mini-css-extract-plugin
export default {"deleteButton":"QNpw8p4_BmexGw4RNwwO","customButton":"whqIWfdRvsFqu3aMdKFX","snapshot":"P10F3_EaOicsXnOnnA0s"};